import { render, staticRenderFns } from "./footBox.vue?vue&type=template&id=d1027a08&scoped=true"
import script from "./footBox.vue?vue&type=script&lang=ts"
export * from "./footBox.vue?vue&type=script&lang=ts"
import style0 from "./footBox.vue?vue&type=style&index=0&id=d1027a08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1027a08",
  null
  
)

export default component.exports